import { render, staticRenderFns } from "./sysDictionaryList.vue?vue&type=template&id=ba60bd1e&scoped=true&"
import script from "./sysDictionaryList.vue?vue&type=script&lang=js&"
export * from "./sysDictionaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba60bd1e",
  null
  
)

component.options.__file = "sysDictionaryList.vue"
export default component.exports